export default class DtoCodificationContributor {
    constructor(object) {
        this.idContributor = object.idContributor
        this.startDate = object.startDate
        this.endDate = object.endDate
        this.codificationType = object.codificationType
        this.codification = object.codification
    }
}